/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Box, Button, Stack } from "@mui/material";
import { useSortableComponentList } from "cms/components/hooks/use-sortable-component-list";
import { SVGIcons } from "cms/icons/svg-icons";
import { AddLineWithIcon } from "components/add-line-with-icon";
import LabelledField from "components/labelled-field";
import PositionButtons from "components/position-buttons";
import RemoveIcon from "components/remove-icon";
import { SortableContent } from "components/sortable-content";
import { Fragment } from "react";
// import { useTranslation } from 'react-i18next';
import { isArrayNotEmpty } from "utils/empty-exists";
import { ComponentSlideshowContext } from "./component-slideshow-context";

const defaultSlideshowSlide = Object.freeze({
    title: "",
    description: {},
    image: {},
    link: {},
});

const SlideshowComponentEditWrapper = (props) => {
    
    // const { t } = useTranslation();
    const {
        slides: initialSlides = [],
        onChangeList,
        children,
    } = props;

    if (typeof onChangeList !== "function") {
        throw Error("onChangeList was not supplied, or is not a function");
    }

    const {
        list,
        sortableMethods,
        controls,
    } = useSortableComponentList(initialSlides, defaultSlideshowSlide, onChangeList);

    const {
        addNewItem,
        addNewItemBelow,
        removeItem,
        updateItems
    } = controls;

    return (
        <Fragment>
            <LabelledField
                label="Hero Slideshow"
                style={{ marginTop: 12 }}
            >
                <Box style={{ paddingTop: 6, display: "flex", gap: 12 }}>
                    <Button
                        size='medium'
                        variant='contained'
                        color={"primary"}
                        target='warning'
                        onClick={addNewItem}
                    >
                        <SVGIcons.common.Create style={{ paddingRight: 4, cursor: "pointer" }} />
                        Add Slide
                    </Button>
                </Box>
            </LabelledField>
            <div className='simplicity-slideshow-wrapper'>
                <Stack direction='column'>
                    {isArrayNotEmpty(list) && list.map((item, index) => {
                        const { guid } = item;
                        const componentSlideshowContext = {
                            list,
                            guid,
                            item,
                            index,
                            position: index,
                            addNewItem,
                            updateItems,
                            removeItem,
                        };
                        return (
                            <ComponentSlideshowContext.Provider
                                key={`slideshow-${guid}`}
                                value={componentSlideshowContext}
                            >
                                <SortableContent
                                    id={guid}
                                    index={index}
                                    sortableMethods={sortableMethods}
                                >
                                    {children}
                                    <div>
                                        <PositionButtons
                                            index={index}
                                            list={list}
                                            handleUpdate={updateItems}
                                        />
                                        <RemoveIcon
                                            className='simplicity-composer-field-editor-remove'
                                            onDeleteItem={() => removeItem(index)}
                                            index={index}
                                        />
                                    </div>
                                </SortableContent>
                                <AddLineWithIcon
                                    addNewItem={() => addNewItemBelow(index)}
                                />
                            </ComponentSlideshowContext.Provider>
                        );
                    })}
                </Stack>
            </div>
        </Fragment>
    );
};
SlideshowComponentEditWrapper.displayName = "SlideshowComponentEditWrapper";
export { SlideshowComponentEditWrapper };
